import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import { application } from '@/settings';

const getComponent = (Src, customClass) => {
  if (typeof Src === 'string') {
    return <img className={classNames(customClass, 'w-full mx-0 cursor-pointer max-h-10')} src={Src}
      alt={application.name}/>;
  }
  return <Src className={classNames(customClass, 'w-full mx-0 cursor-pointer max-h-10')}/>;
};

const Logo = ({ mini, customClass }) => {
  return <Link to="/" className="flex items-center">
    {mini ? getComponent(application.logo.srcMin, customClass) : getComponent(application.logo.src, customClass)}
  </Link>;
};

Logo.propTypes = {
  customClass: PropTypes.any,
  mini: PropTypes.any
};

export default memo(Logo);
